import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

import { bookMarketingImg2, bookFormattingImg2 } from "../../asserts/images";

const BookFormatting = () => {
  return (
    <>

    <Helmet>
        <meta charSet="utf-8" />
        <title>
            Hire #1 Book Formatters – Amazon Formatting Services
        </title>
        <meta
          name="description"
          content="Hire top book formatters with Falcon Book Writing to professionally format your Amazon book, ensuring a polished, reader-friendly layout ready for publishing."
        />
        <meta name="keywords" content="Book Formatters" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="bookFormattingBg"
          title="Make Every Page Perfect With Expert"
          subtitle=" Book Formatting"
          para="Ensure your manuscript shines with expert book formatting. Every page, chapter, and layout is meticulously polished for readability, consistency, and professional presentation, creating a seamless reading experience that enhances your book’s impact and appeal."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section"
          title="Every Page, Chapter, and Section Perfectly"
          subtitle=" Structured "
        //   title2="Your Narrative"
        //   subtitle1="How we work?"
          description="A well-structured book isn’t just visually appealing, it enhances the entire reading experience. Every page, chapter, and section plays a vital role in guiding readers seamlessly through your story or message. Our professional book formatting service ensures that each element of your manuscript is organized with precision, creating a polished, cohesive, and visually engaging layout. From margins and spacing to headings, fonts, and chapter breaks, every detail is meticulously crafted for both print and digital formats. Proper structure improves readability, emphasizes key points, and allows your content to shine. Whether your book is fiction, non-fiction, or a specialized guide, structured formatting elevates its professionalism and impact. With our expertise, your manuscript transforms into a book that looks as compelling as the words it holds."
          // subtitle1="How we work?"
          // subtitle2="    Tailored Collaborations?"
          // subtitle3="  Expert Guidance"
          image={bookFormattingImg2}
          imgClass="bookFormattingImg2"
          actions={true}
          btn1="Let’s Get Start"
          btn2="Call Us Now"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default BookFormatting;
